<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="450px"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        x-small
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Work Session Shift Codes"
      text="Update work session shift code"
      class="mb-0"
      :loading="loading"
    >
      <form v-if="dialog && !loading">
        <v-container
          class="overflow"
          data-simplebar
        >
          <v-row no-gutters>
            <v-col cols="12">
              <v-text-field
                v-model="localShiftCode.code"
                v-validate="'required'"
                :error-messages="errors.collect('code')"
                data-vv-name="code"
                data-vv-as="code" 
                label="Code"
                outlined
              />
            </v-col>
            <v-col 
              cols="6"
              class="py-0 pr-2"
            >
              <v-text-field
                v-model="localShiftCode.start_time"
                v-validate="'required|time_before_or_equal:' + localShiftCode.end_time"
                :error-messages="errors.collect('startTime')"    
                data-vv-name="startTime"
                data-vv-as="start time"
                outlined
                label="Start Time"
                type="time"
              />
            </v-col>
            <v-col 
              cols="6"
              class="py-0 pl-2"
            >
              <v-text-field
                v-model="localShiftCode.end_time"
                v-validate="'required|time_after_or_equal:' + localShiftCode.start_time"
                :error-messages="errors.collect('endTime')"    
                data-vv-name="endTime"
                data-vv-as="end time"
                outlined
                label="End Time"
                type="time"
              />
            </v-col>
            <v-col
              cols="12"
            >
              <v-textarea
                v-model="localShiftCode.description"
                :rows="2"
                outlined
                label="Description"
              />
            </v-col>
          </v-row>
        </v-container>
      </form> 

      <v-card-actions v-if="dialog && !loading">
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Cancel
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"    
          class="white--text px-10"      
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions> 
    </material-card>  
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      workSessionShiftCode: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        dialog: null,
        progressing: false,
        localShiftCode: null,
        loading: false,
      }
    },

    watch: {
      dialog: function (value) {
        if (!value) return
        this.localShiftCode = { ...this.workSessionShiftCode }

        function toMinutes (time) {
          if (!time) return null
          const [h, m] = time.split(':')
          return (parseInt(h) * 60) + parseInt(m)
        }

        this.$validator.extend('time_before_or_equal', {
          getMessage (field, args) {
            return `The ${field} must be earlier than end time.`
          },
          validate (value, args) {
            const [otherValue] = args
            return toMinutes(value) <= toMinutes(otherValue)
          },
        })

        this.$validator.extend('time_after_or_equal', {
          getMessage (field, args) {
            return `The ${field} must be later than start time.`
          },
          validate (value, args) {
            const [otherValue] = args
            return toMinutes(value) >= toMinutes(otherValue)
          },
        })
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true

            this.$api.shiftCodes().update(this.workSessionShiftCode.id, this.prepareFormData())
              .then(response => {
                this.$emit('updated')
                this.$snack({ message: response.data.status })

                this.progressing = false
                this.dialog = false
              })
              .catch((err) => {
                if (err.response.status === 405) {              
                  this.$snack({ 
                    color: 'error',
                    message: err.response.data.message, 
                  })
                }            
            
                this.progressing = false
              })
          })
      },

      prepareFormData () {
        return {
          code: this.localShiftCode.code,
          description: this.localShiftCode.description,
          start_time: this.localShiftCode.start_time,
          end_time: this.localShiftCode.end_time,
        }
      },

    },
  }
</script>
